import React, { useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router";

import DistributionSystemsTable from "./DistributionSystemsTable";
import GroupedSamplingStationTable from "./GroupedSamplingStationTable";
import HeaderBox from "../../reuseableComponents/headerBox";
import PumpingStationTable from "./PumpingStationTable";
import ServiceConnectionTable from "./ServiceConnectionsTable";
import SiteVisitHistoryTable from "./SiteVisitHistoryTable";
import SourcesTable from "./SourceTable";
import TreatmentPlantsTable from "./TreatmentPlantsTable";
import StorageTable from "./StorageTable";
import NotAuthorized from "../../reuseableComponents/auth/NotAuthorized";
import { UserContext } from "../../reuseableComponents/auth/UserContext";

const InventoryReport = () => {
  const { user } = useContext(UserContext);
  let { systemId } = useParams();
  if (user.isStaff || user.isSysAdmin) {
    return (
      <>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='inventoryReport'>
              <h3 style={{ color: "#fff" }}>Inventory Report</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <h3 data-cy='serviceConnections'>Service Connections</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <ServiceConnectionTable systemId={parseInt(systemId)} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>Treatment Plants</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <TreatmentPlantsTable systemId={parseInt(systemId)} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>Storage</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <StorageTable systemId={parseInt(systemId)} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>Pumping Stations</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <PumpingStationTable systemId={parseInt(systemId)} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>Sources</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <SourcesTable systemId={parseInt(systemId)} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>Grouped Source Sampling Stations</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <GroupedSamplingStationTable systemId={parseInt(systemId)} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>Distribution System</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <DistributionSystemsTable systemId={parseInt(systemId)} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>Site Visit History</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <SiteVisitHistoryTable systemId={parseInt(systemId)} />
          </Col>
        </Row>
      </>
    );
  } else {
    return <NotAuthorized />;
  }
};
export default InventoryReport;
